import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class MissingAccountsReportCriteria extends ValueObject  
{
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";
}